import { useContext } from "react";

import { localizedNamespaceContext } from "../contexts/localized-namespace";

export const useLocalizedNamespace = () =>
    useContext(localizedNamespaceContext);
